import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { UsuarioIndexComponent } from './usuario-index/usuario-index.component';
import { UsuarioViewComponent } from './usuario-view/usuario-view.component';
import { UsuarioCreateComponent } from './usuario-create/usuario-create.component';
import { UsuarioUpdateComponent } from './usuario-update/usuario-update.component';
import { UsuarioGeneratePassComponent } from './usuario-generate-pass/usuario-generate-pass.component';

const routes: Routes = [
  { path: '', redirectTo: 'index', pathMatch: 'full' },
  { path: 'index', component: UsuarioIndexComponent },
];

@NgModule({
  declarations: [
    UsuarioIndexComponent,
    UsuarioViewComponent,
    UsuarioCreateComponent,
    UsuarioUpdateComponent,
    UsuarioGeneratePassComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgbModalModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule,
  ]
})
export class UsuarioModule { }
